import React from "react";
import { SelectClinicSearchScreen } from "~/features/book-appointment/SelectClinicSearchScreen";

const Component = () => {
  return <SelectClinicSearchScreen />;
};

export default Component;
